<template>
	<a-result status="404" title="404" sub-title="Lo sentimos, la pagina que buscas no existe.">
		<template #extra>
			<router-link to="/inicio" class="ant-btn ant-btn-primary">
				Inicio
			</router-link>
			
		</template>
	</a-result>
</template>
<script>
	export default {
		data(){
			return{

			}
		},
		methods:{
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>